import { booleanEnvVariable } from 'helpers/envParser'

export const IS_BETA = booleanEnvVariable(process.env.REACT_APP_IS_BETA),
  SHOW_DEBUG = IS_BETA,
  HIDE_ADS = booleanEnvVariable(process.env.REACT_APP_HIDE_ADS),

  IS_BETA_DOMAIN = Boolean(~document.location.origin.indexOf('beta')),
  IS_RELEASE_DOMAIN = Boolean(~document.location.origin.indexOf('release')),
  IS_PROD_DOMAIN = Boolean(~document.location.origin.indexOf('sportvokrug'));
